import React, { useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import { LoadingAnimation } from '../../common/components/Utilities';
import LegacyUserResource from '../../common/resource/LegacyUserResource';

function FeedbackAlert({ errorMessage, clearErrorMessage }) {
  if (errorMessage) {
    return (
      <Alert variant="danger" onClose={clearErrorMessage} dismissible>
        <p>{errorMessage}</p>
      </Alert>
    );
  }
  return null;
}

function ShowButtons({
  isLoggedUserOrAdmin, editingFunFact, setEditingFunFact, funFact, clickSave,
}) {
  const buttonResponse = [];
  if (isLoggedUserOrAdmin && !editingFunFact) {
    buttonResponse.push(
      <button key="1" type="button" className="mt-2 btn btn-sm btn-secondary" onClick={() => setEditingFunFact(true)}>
        {funFact.current.length ? 'Edit' : 'Add'}
        {' '}
        Fun Fact
      </button>,
    );
  }
  if (editingFunFact) {
    buttonResponse.push(<button key="1" className="mt-2 btn btn-sm mr-1 btn-secondary" type="button" onClick={() => setEditingFunFact(false)}>Cancel</button>);
    buttonResponse.push(<button key="2" className="mt-2 btn btn-sm btn-primary" type="button" onClick={clickSave}>Save</button>);
  }
  return (
    <div className="text-right">
      {buttonResponse}
    </div>
  );
}

function UserProfileFunFact({ profileUser, activeUser }) {
  const isActiveUserSameAsProfileUser = activeUser.id === profileUser.id;
  const isLoggedUserOrAdmin = (isActiveUserSameAsProfileUser) || activeUser.is_admin;
  const [editingFunFact, setEditingFunFact] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [areaHeight, setAreaHeight] = useState(0);
  const [funFact, setFunFact] = useState({
    current: profileUser.fun_fact,
    new: profileUser.fun_fact,
  });
  const response = [];
  let errorTimeoutId;

  function clearErrorMessage() {
    clearTimeout(errorTimeoutId);
    setErrorMessage('');
  }

  const changeErrorMessage = () => {
    setErrorMessage('Server error while saving fun fact, please try again.');
    errorTimeoutId = setTimeout(() => {
      setErrorMessage('');
    }, 6000);
  };

  const changeFunTextarea = (event) => {
    // This is not ideal when going from a large height to a very small one.
    // For some reason the scrollHeight reduces each time by 2 until it
    // reaches the right height again
    setAreaHeight(event.target.scrollHeight);
    setFunFact({ current: funFact.current, new: event.target.value });
  };

  const clickSave = async () => {
    clearErrorMessage();
    setLoading(true);

    try {
      const serverResponse = await LegacyUserResource
        .update(profileUser.id, { fun_fact: funFact.new });
      if (serverResponse) {
        setFunFact({
          current: funFact.new,
          new: funFact.new,
        });
        setEditingFunFact(false);
      } else {
        changeErrorMessage();
      }
    } catch (error) {
      changeErrorMessage();
    } finally {
      setLoading(false);
    }
  };

  if (funFact.current.length && !editingFunFact) {
    response.push(<p key="1" className="mb-2 text-left">{funFact.current}</p>);
  }

  if (isLoggedUserOrAdmin && editingFunFact) {
    response.push(<label key="1" htmlFor="fun_fact" className="text-left d-block"><strong>Fun Fact</strong></label>);
    response.push(<textarea
      key="2"
      id="fun_fact"
      name="fun_fact"
      rows="3"
      className="form-control"
      style={{
        maxWidth: '100%', maxHeight: '250px', minHeight: areaHeight, fontSize: '0.9rem',
      }}
      maxLength="500"
      placeholder={`Tell us a fun fact about ${isActiveUserSameAsProfileUser ? 'yourself' : profileUser.name}...`}
      onChange={changeFunTextarea}
      value={funFact.new}
    />);
  }

  return (
    <>
      <hr />
      <FeedbackAlert clearErrorMessage={() => clearErrorMessage()} errorMessage={errorMessage} />
      <LoadingAnimation loading={loading} />
      {response}
      <ShowButtons
        isLoggedUserOrAdmin={isLoggedUserOrAdmin}
        editingFunFact={editingFunFact}
        setEditingFunFact={setEditingFunFact}
        funFact={funFact}
        clickSave={clickSave}
      />
    </>
  );
}

export default UserProfileFunFact;
